/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */

/* eslint-disable @typescript-eslint/camelcase */
import React from 'react'
import DistChart from './ChartComponents/Distribution'
import LinkIcon from './OutboundLinkComponent'
import PropTypes from 'prop-types'
import List from '../../../components/List'
import DownCarot from '../../../assets/icons/carat.svg'

class Motor extends React.Component {
  constructor(props) {
    super(props)

    // getinitialState
    this.state = {
      dominant: this.DominantHand(),
      nondominant: this.NonDominantHand()
    }
  }

  UNSAFE_componentWillReceiveProps() {
    this.setState({
      dominant: this.DominantHand(),
      nondominant: this.NonDominantHand()
    })
  }

  DominantHand() {
    const { details } = this.props
    let stats = details.dominant

    return {
      display_label: stats.display_label,
      unit: stats.unit,
      value: stats.value,
      interpretation: stats.interpretation,
      percentile: stats.percentile,
      ranges: stats.ranges,
      test_name: stats.test_name,
      density_plot: stats.density_plot
    }
  }

  NonDominantHand() {
    const { details } = this.props
    let stats = details.non_dominant

    return {
      display_label: stats.display_label,
      unit: stats.unit,
      value: stats.value,
      interpretation: stats.interpretation,
      percentile: stats.percentile,
      ranges: stats.ranges,
      test_name: stats.test_name,
      density_plot: stats.density_plot
    }
  }

  render() {
    const { index, details, hotload } = this.props

    const items = {
      physicalActivity: {
        title: '<h2 class="mobile-padding">Dexterity</h2>',
        icon: { src: DownCarot },
        isShowAccordianOnMobile: true,
        accordianContent: `
      <div class="mobile-padding">
            <div>
              <p class="noMarginPadding">
                Dexterity is a person’s ability to coordinate the fingers and
            manipulate objects in a timely manner.
            <br />
            <br />
            Dexterity
            <a
              href="http://www.jhandtherapy.org/article/S0894-1130(14)00131-8/fulltext"
              target="_blank"
              rel="noopener noreferrer"
            >
              improves with age <LinkIcon />
            </a>
            through childhood, and declines beyond age 60.
              </p>
            </div>
              <br/>
          </div>`
      }
    }
    const listProps = {
      items,
      isMobile: this.props.isMobile,
      isNoTopBorder: true,
      isNotSpacer: true,
      isCollapsedDark: true,
      isReportStyle: true
    }

    return (
      <div className="dexterity-content module-content">
        <div className="intro-zone">
          {this.props.isMobile ? (
            <List {...listProps} />
          ) : (
            <p>
              Dexterity is a person’s ability to coordinate the fingers and
              manipulate objects in a timely manner.
              <br />
              <br />
              Dexterity{' '}
              <a
                href="http://www.jhandtherapy.org/article/S0894-1130(14)00131-8/fulltext"
                target="_blank"
                rel="noopener noreferrer"
              >
                improves with age <LinkIcon />
              </a>{' '}
              through childhood, and declines beyond age 60.
            </p>
          )}
        </div>
        {!this.props.isMobile && <hr />}

        {hotload ? (
          <div className="mobile-padding">
            <div className="bucket">
              <div className="table">
                <div className="trow dominant">
                  <div className="td even-width">
                    <strong className="subject">
                      {details.dominant.display_label}
                    </strong>
                  </div>
                  <div className="td even-width">
                    <strong className="value">{details.dominant.value}</strong>
                    <span className="descriptor">Score</span>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.dominant.percentile}%
                    </strong>
                    <span className="descriptor">Percentile</span>
                  </div>
                  <div className="td">
                    <DistChart
                      label={'DominantHand'}
                      details={details}
                      index={index}
                      data={this.state.dominant}
                    />
                  </div>
                </div>
              </div>
              {!details.dominant.__ok ? (
                <div className="no-report-data">
                  {`No ${details.dominant.display_label} Data Available`}
                </div>
              ) : null}
            </div>
            <hr />
            <div className="bucket">
              <div className="table">
                <div className="trow nondominant">
                  <div className="td even-width">
                    <strong className="short-subject subject">
                      {details.non_dominant.display_label}
                    </strong>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.non_dominant.value}
                    </strong>
                    <span className="descriptor">Score</span>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.non_dominant.percentile}%
                    </strong>
                    <span className="descriptor">Percentile</span>
                  </div>
                  <div className="td">
                    <DistChart
                      label={'NonDomHand'}
                      details={details}
                      index={index}
                      data={this.state.nondominant}
                    />
                  </div>
                </div>
              </div>
              {!details.non_dominant.__ok ? (
                <div className="no-report-data">
                  {`No ${details.non_dominant.display_label} Data Available`}
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
    )
  }
}

Motor.propTypes = {
  details: PropTypes.object.isRequired
}

export default Motor
